import { ButtonSubmit, DialogProps, Select, useListGraphqlQuery } from "@bsm/component"
import { useEffect, useMemo, useState } from "react";
import { useAddStudentMutation } from "../views/details/hooks/useAddStudentMutation";
import _ from "lodash";
import { ConfirmAddStudentDialog } from "./ConfirmAddStudentDialog";
import { TUserStudentScholarity } from "@bsm/graphql";
import { useGetStudentsQuery } from "../views/create/hooks/useGetStudentsQuery";
import { useScholarityQuery } from "../views/details/hooks/useScholarityQuery";
import { STUDENT_LIST_ID } from "views/list/containers/StudentListContainer";
import { StudentsList } from "./StudentsList";
import { SCHOLARITY_LIST_ID } from "../container/ScholarityListContainer";


export const ManageStudents = (props: TProps) => {

    const [studentConfirmation, setStudentConfirmation] = useState<any>({ open: false, confirmation: {} })
    const [selectedStudent, setSelectedStudent] = useState<any>(null)
    const mutation = useAddStudentMutation()
    const { invalidateQuery: invalidateQueryScholarity } = useScholarityQuery(props?.id ? props.id : undefined, true)
    const { invalidateQuery: invalidateStudentListQuery } = useListGraphqlQuery(STUDENT_LIST_ID);
    const { invalidateQuery: invalidateScholarityListQuery } = useListGraphqlQuery(SCHOLARITY_LIST_ID);
    const { data, invalidateQuery } = useGetStudentsQuery({}, true)

    useEffect(() => {
        if (mutation.isSuccess) {
            invalidateQuery()
            invalidateQueryScholarity()
            invalidateStudentListQuery()
            invalidateScholarityListQuery()
            setSelectedStudent([])
        }
    }, [mutation.isSuccess])

    const students = useMemo(() => {
        const studentNotYetInsideScholarity = data?.data.filter(item => !props?.students?.map(student => student?.id).includes(item?.id))
        return studentNotYetInsideScholarity?.filter(student => !student.isEnrolled)?.map(item => ({
            label: item?.user?.fullName,
            value: item?.id,
            userId: item?.user?.id
        }))
    }, [data, props?.students])

    const onCloseConfirmation = () => {
        setStudentConfirmation({ open: false, confirmation: {} })
        invalidateQuery()
        invalidateQueryScholarity()
        invalidateStudentListQuery()
        invalidateScholarityListQuery()
        setSelectedStudent([])
    }

    const handleSubmited = () => {
        mutation.mutate(
            { scholarityId: props?.id, studentIds: selectedStudent },
            {
                onError: (err) => {
                    if (err?.xhr.status === 400 || err?.xhr.status === 401) {
                        const errors = JSON.parse(err.response).errors
                        setStudentConfirmation({
                            open: true,
                            confirmation: errors
                        })
                    }
                }
            }
        )
    }

    return (
        <div className="flex flex-col gap-2 mt-4">
            <div className="flex flex-col gap-2 w-full">
                <Select 
                    options={students}
                    multiple
                    onChange={(value) => {
                        setSelectedStudent(value)
                    }}
                    value={selectedStudent}
                />
            </div>
            <ButtonSubmit
                className="btn-primary"
                startIcon="fa-solid fa-users"
                label={"Add students"}
                onClick={handleSubmited}
                loading={mutation.isLoading}
                disabled={_.isEmpty(selectedStudent) || mutation.isLoading}
            />
            <StudentsList {...props} onConfirm={onCloseConfirmation} />
            <ConfirmAddStudentDialog
                scholarityId={props?.id}
                studentIds={selectedStudent}
                open={studentConfirmation?.open}
                message={studentConfirmation?.confirmation}
                onClose={onCloseConfirmation}
            />
        </div>
    )
}

type TProps = Partial<TUserStudentScholarity> & Partial<DialogProps> 